/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Label_PausedInputs */

const en_wb_label_paused = /** @type {(inputs: Wb_Label_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused by you`)
};

const lv_wb_label_paused = /** @type {(inputs: Wb_Label_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūs apturējāt`)
};

/**
* | output |
* | --- |
* | "Paused by you" |
*
* @param {Wb_Label_PausedInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_label_paused = /** @type {((inputs?: Wb_Label_PausedInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Label_PausedInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_label_paused(inputs)
	return en_wb_label_paused(inputs)
});